import { Cotizacion } from "./cotizacion";
import { TareaResponsable } from "../forms/tareas/tarea-responsables/tarea-responsable/tarea-responsable";

export class TareaTipo {
    constructor(
        public IdTareaTipo: number | string = null,
        public descripcion: string = ''
    ) { }
}

export class Tarea {
    constructor(
        public IdTarea: number | string = null,
        public titulo: string = '',
        public fechaTarea: string = '',
        public horaTarea: string = '',
        public fechaNotificacion: string = '',
        public horaNotificacion: string = '',
        public descripcion: string = '',
        public cantidadResponsables: number = null, // cantidad de responsables asignados a la tarea
        public totalCompletadasResponsables: number = null, // cantidad de responsables que la completaron,
        public cotizacion: Cotizacion = new Cotizacion(), // la tarea PUEDE (o no) estar asignada a una cotización
        public tipoTarea: TareaTipo = new TareaTipo(),
        public soyResponsable: TareaResponsable = null // si el usuario logueado es responsable se carga este campo
    ) { }
}